import { ComponentType, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export function getImageRoute(filename: string): string {
    return `images/${filename}`;
}

export const getUrlParameter = (search: string, name: string): string | undefined => {
    const escapedName = escapeRegExp(name);
    const regex = new RegExp("[\\?&]" + escapedName + "=([^&#]*)");
    const results = regex.exec(search);

    return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const getRoutePageIndex = (routeIndexParam: string): number => {
    return Number(routeIndexParam) && Number(routeIndexParam) - 1 >= 0 ? Number(routeIndexParam) : 1;
};

export const getApiUrlVersioning = (apiUrl: string): string => {
    const { 1: capturedValue } = apiUrl.match(/^.*\/(v[0-9])$/) || { 1: null };
    return capturedValue;
};

export const useQuery = (): URLSearchParams => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
};

// https://whereisthemouse.com/how-to-use-withrouter-hoc-in-react-router-v6-with-typescript
export interface WithRouterProps {
    location: ReturnType<typeof useLocation>;
    params: Record<string, string>;
    navigate: ReturnType<typeof useNavigate>;
}

/** @deprecated Use `React Router hooks` instead */
export const withRouter = <Props extends WithRouterProps>(Component: ComponentType<Props>) => {
    const WithRouterBase = (props: Omit<Props, keyof WithRouterProps>) => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();

        return <Component {...(props as Props)} location={location} params={params} navigate={navigate} />;
    };
    WithRouterBase.displayName = "withRouter";
    return WithRouterBase;
};

function escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
